import { FC } from 'react'

import { CenterText } from '../../../brunswick/components/atoms/CenterText'

import { Body, Caption, Icon } from './styles'

export type IconSize = 'small' | 'large' | 'extraLarge'

type DeprecatedZidiIconBadge = {
  caption: string | null
  captionColor?: string
  icon: { url: string } | null
  iconText: string | null
}

export type IconBadge =
  | DeprecatedZidiIconBadge
  | {
      text: string | null
      caption: string | null
      captionColorHexCode: string | null
      image: { url: string }
    }

export const IconBadge: FC<IconBadge & { className?: string; size: IconSize }> = ({
  className,
  size,
  ...props
}) => {
  const caption = props.caption
  const image = 'image' in props ? props.image : props.icon
  const text = 'text' in props ? props.text : props.iconText
  const captionColorHexCode =
    'captionColorHexCode' in props ? props.captionColorHexCode : props.captionColor
  if (!caption && !image && !text) return null

  const iconSrc = image?.url

  return (
    <Body className={className} size={size}>
      {(iconSrc || text) && (
        <Icon iconSrc={iconSrc} size={size}>
          <CenterText letterSpacing='0.05em'>{text}</CenterText>
        </Icon>
      )}
      {caption && (
        <Caption size={size} captionColor={captionColorHexCode ?? undefined}>
          <CenterText letterSpacing='0.05em'>{caption}</CenterText>
        </Caption>
      )}
    </Body>
  )
}
